import * as React from "react"
import Seo from "@components/seo"
import Layout from "@layout"
import Header from "@layout/header/header-one"
import Footer from "@layout/footer/footer-one"
import Banner from "@components/banners/Ai";
import ConferencesArea from "@containers/conferences-area"

const ConferencesPage = ({pageContext, location }) => (
  <Layout location={location}>
    <Seo title="Publications of Referred Conferences" />
    <Header />
    { <Banner
			pageContext={pageContext}
			location={location}
			title="The Publications of Referred Conferences"
		/> }
    <main className="site-wrapper-reveal">
      <ConferencesArea />
    </main>
    <Footer />
  </Layout>
)

export default ConferencesPage
